import React from 'react';
import { Link } from 'gatsby';

import CapabilityList from './CapabilityList';

const Capabilities = () =>
  <section id="two" className="wrapper style3 fade-up">
    <div className="inner">
      <h2>Experience and Hobbies</h2>
      {/* <p>
        I am working as a Systems Analyst, but am looking to move into web development.
      </p> */}
      <div className="features">
        <CapabilityList />
      </div>
      <ul className="actions">
        <li>
          <Link className="button" to="/generic">
            Resume
          </Link>
        </li>
      </ul>
    </div>
  </section>

export default Capabilities;
